export default {
  errorDefault: 'Det oppstod en feil',
  unknown: 'Ukjent',
};
